import axios from "axios";
import { PHP_LOGOUT_URL, NEW_SESSION_API_URL } from "@/services/ServiceConstants";

export const cleanURLParam = (param) => {
  if (!param || typeof param !== "string") return param;

  return param.split("?")[0].split("&")[0].split("#")[0].trim();
};

export const getSessionDataNew = ({ getSessionData = true, checkLoginOnly = false } = {}) => {
  const searchParams = new URLSearchParams(window.location.search);
  const theuserid = cleanURLParam(searchParams.get("theuserid") || "");

  const postData = {
    ...(getSessionData && !checkLoginOnly ? { getSessionData: 1 } : {}),
    ...(checkLoginOnly ? { checkLoginOnly: 1 } : {}),
    ...(theuserid ? { theuserid } : {}),
  };

  return new Promise((resolve, reject) => {
    axios
      .post(NEW_SESSION_API_URL + (theuserid ? `?theuserid=${theuserid}` : ""), postData, { withCredentials: true })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const updateDashboardLanguage = (lang) => {
  const searchParams = new URLSearchParams(window.location.search);
  const theuserid = cleanURLParam(searchParams.get("theuserid") || "");

  return new Promise((resolve, reject) => {
      axios
        .post(
          NEW_SESSION_API_URL + (theuserid ? `?theuserid=${theuserid}` : ""),
          { updateDashboardLanguage: true, setLanguage: lang },
          { withCredentials: true }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject("Error", err);
        });
  });
};

// Logout PHP when react logout is triggered  (Only required for multiple enviornments)
export const logoutPHP = () => {
  return new Promise((resolve, reject) => {
      axios
        .get(PHP_LOGOUT_URL, { withCredentials: true })
        .then((response) => resolve(response))
        .catch((err) => {
        reject("Error in php logout", err);
        });
  });
};
